module.exports = __webpack_public_path__ + "img/640x480.74c6b2af.png";